export default function MobileHeader({ title, streakCount }) {
  const radius = 12;
  const circumference = 2 * Math.PI * radius;
  const progress = streakCount ? Math.min(streakCount / 30, 1) : 0;
  const dashLength = progress * circumference;

  return (
    <header
      className="mobile-header"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 999,
        minHeight: "56px",
        boxSizing: "border-box",
        paddingTop: "env(safe-area-inset-top)",
        background: "rgba(16, 16, 16, 0.85)",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: "20px",
        paddingRight: "20px",
        borderBottom: "1px solid rgba(185, 151, 255, 0.08)",
      }}
    >
      {/* Left — Brand + Page Name */}
      <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
        <span
          style={{
            color: "#ffffff",
            fontSize: "16px",
            fontWeight: 800,
            textTransform: "uppercase",
            letterSpacing: "3px",
            lineHeight: 1.2,
          }}
        >
          DISBOUND
        </span>
        <span
          style={{
            color: "#b997ff",
            fontSize: "10px",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "4px",
            lineHeight: 1.2,
          }}
        >
          {title}
        </span>
      </div>

      {/* Right — Streak Ring */}
      {streakCount != null && (
        <div
          style={{
            position: "relative",
            width: "34px",
            height: "34px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            style={{ transform: "rotate(-90deg)" }}
          >
            {/* Background track */}
            <circle
              cx="17"
              cy="17"
              r={radius}
              fill="none"
              stroke="rgba(185, 151, 255, 0.15)"
              strokeWidth="2.5"
            />
            {/* Progress arc */}
            <circle
              cx="17"
              cy="17"
              r={radius}
              fill="none"
              stroke="#b997ff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeDasharray={`${dashLength} ${circumference}`}
            />
          </svg>
          <span
            style={{
              position: "absolute",
              color: "#ffffff",
              fontSize: "11px",
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            {streakCount}
          </span>
        </div>
      )}
    </header>
  );
}
